import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { Box, Container, Typography, Divider } from "@mui/material";

class Terms extends Component {
  render() {
    return (
      <Box sx={{ py: 13 }}>
        <Helmet>
          <title>Terms &amp; Conditions | F9 Info Technologies</title>
          <meta name="description" content="Read the Terms and Conditions governing the use of F9 Info Technologies services and website." />
        </Helmet>
        <Container maxWidth="lg" className="container">
          <Typography variant="h1" component="h1" className="page-title" align="center" sx={{ mb: 2 }}>
            Terms &amp; Conditions
          </Typography>
          <Typography align="center" sx={{ mb: 6, color: "text.secondary" }}>
            Effective Date: January 1, 2024
          </Typography>

          <Section title="1. Acceptance of Terms">
            By accessing or using the website, products, or services of F9 Info Technologies Private Limited
            ("F9 Tech", "we", "our", or "us"), you agree to be bound by these Terms &amp; Conditions. If you
            do not agree, please discontinue use of our services immediately.
          </Section>

          <Section title="2. Services">
            F9 Info Technologies provides software development, mobile application development, web application
            development, digital marketing, graphic designing, UI/UX design, and business solution services.
            We reserve the right to modify, suspend, or discontinue any service at any time without prior notice.
          </Section>

          <Section title="3. Intellectual Property">
            All content, design, graphics, code, and materials on this website are the exclusive property of
            F9 Info Technologies Private Limited and are protected under applicable intellectual property laws.
            You may not reproduce, distribute, or use any content without prior written permission from us.
          </Section>

          <Section title="4. Client Responsibilities">
            Clients are responsible for providing accurate project requirements, timely feedback, and necessary
            access to resources required for project delivery. Delays caused by the client may affect delivery
            timelines and are not the responsibility of F9 Info Technologies.
          </Section>

          <Section title="5. Payment Terms">
            Payment terms are agreed upon in individual project contracts. F9 Info Technologies reserves the
            right to pause or terminate project work in the event of non-payment. All payments are
            non-refundable unless otherwise stated in writing.
          </Section>

          <Section title="6. Confidentiality">
            Both parties agree to keep confidential any proprietary information shared during the course of
            a project engagement. This obligation continues for two (2) years after the conclusion of the project.
          </Section>

          <Section title="7. Limitation of Liability">
            F9 Info Technologies shall not be liable for any indirect, incidental, special, or consequential
            damages arising from the use of our services or website. Our total liability shall not exceed the
            amount paid by the client for the specific service in question.
          </Section>

          <Section title="8. Governing Law">
            These Terms &amp; Conditions shall be governed by and construed in accordance with the laws of
            India. Any disputes shall be subject to the exclusive jurisdiction of the courts in Visakhapatnam,
            Andhra Pradesh, India.
          </Section>

          <Section title="9. Changes to Terms">
            We reserve the right to update these Terms &amp; Conditions at any time. Changes will be posted
            on this page with an updated effective date. Continued use of our services after changes constitutes
            your acceptance of the revised terms.
          </Section>

          <Section title="10. Contact Us" last>
            For any questions regarding these Terms &amp; Conditions, please contact us at:
            <br /><br />
            <strong>F9 Info Technologies Private Limited</strong><br />
            Vinayagar Heights, Sampath Vinayaka Temple Road,<br />
            Waltair Uplands, Opp. Kalyan Jewellers,<br />
            Visakhapatnam – 530003, Andhra Pradesh, India<br />
            Email: <a href="mailto:projects@f9tech.com">projects@f9tech.com</a><br />
            Phone: <a href="tel:+918919693567">+91 891 969 3567</a>
          </Section>
        </Container>
      </Box>
    );
  }
}

function Section({ title, children, last }) {
  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h5" component="h2" sx={{ mb: 1.5, fontWeight: 600, color: "#002E69" }}>
        {title}
      </Typography>
      <Typography variant="body1" sx={{ lineHeight: 1.8, color: "#444" }}>
        {children}
      </Typography>
      {!last && <Divider sx={{ mt: 4 }} />}
    </Box>
  );
}

export default Terms;
